<template>
  <Modal v-model="editModal" title="今日打卡分配数统计" width="350">
    <!--<div>-->
      <Table height="300" ref="table" :columns="title" :data="tableData" stripe></Table>
    <!--</div>-->
  </Modal>
</template>
<script>
  export default {
    name: 'TodayPunchStatisticsModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        tableData: [],
        title: [
          {
            title: '课程顾问 ',
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.adviserId + '-' + row.adviserName)
            }
          },
          {
            title: '今日分配数 ',
            width: 150,
            align: 'center',
            key: 'countNum'
          }
        ]
      }
    },
    mounted: function () {
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      searchList () {
        var self = this
        this.$http.get('/adviser/getTodayPunchAssignCount').then(function (res) {
          self.tableData = res.data
        })
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      }
    },
    watch: {
      value (val) {
        if (val) {
          this.searchList()
        }
      }
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// TodayPunchStatisticsModal.vue?32065606